import { __awaiter, __decorate, __extends, __generator, __read, __spread, __values } from "tslib";
import React, { useEffect, useState } from 'react';
import { EnhanceConnect } from '@ekuaibao/store';
import { app as api } from '@ekuaibao/whispered';
import { createColumns } from '../data-grid/columnsUtil';
import { isEqual, isString } from 'lodash';
import { getStaffShowByConfig } from '../utilFn';
import { OutlinedEditPin } from '@hose/eui-icons';
import { Tooltip } from '@hose/eui';
import { getBoolVariation } from '../../lib/featbit';
var ColumnProvider = (function (_super) {
    __extends(ColumnProvider, _super);
    function ColumnProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            ready: false
        };
        return _this;
    }
    ColumnProvider.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, Promise.all([api.dataLoader('@common.channelList').load(), api.dataLoader('@common.department').load()])];
                    case 1:
                        _a.sent();
                        this.setState({ ready: true });
                        return [2];
                }
            });
        });
    };
    ColumnProvider.prototype.getColumnDependencySignature = function (props) {
        var _a = props.baseDataProperties, baseDataProperties = _a === void 0 ? [] : _a, _b = props.dynamicChannelMap, dynamicChannelMap = _b === void 0 ? {} : _b, _c = props.mapping, mapping = _c === void 0 ? {} : _c, _d = props.powersList, powersList = _d === void 0 ? [] : _d, scenesType = props.scenesType, useNewFieldSet = props.useNewFieldSet, specialColumn = props.specialColumn, columns = props.columns;
        var baseDataPropertiesSignature = Array.isArray(baseDataProperties)
            ? baseDataProperties
                .map(function (item) {
                var dataType = (item === null || item === void 0 ? void 0 : item.dataType) || {};
                var elemType = (dataType === null || dataType === void 0 ? void 0 : dataType.elemType) || {};
                return [
                    item === null || item === void 0 ? void 0 : item.name,
                    item === null || item === void 0 ? void 0 : item.ability,
                    dataType === null || dataType === void 0 ? void 0 : dataType.type,
                    dataType === null || dataType === void 0 ? void 0 : dataType.entity,
                    elemType === null || elemType === void 0 ? void 0 : elemType.type,
                    elemType === null || elemType === void 0 ? void 0 : elemType.entity
                ].join(':');
            })
                .join('|')
            : '';
        var dynamicChannelMapSignature = Object.keys(dynamicChannelMap)
            .sort()
            .map(function (key) { var _a; return key + ":" + ((_a = dynamicChannelMap[key]) === null || _a === void 0 ? void 0 : _a.active); })
            .join('|');
        var mappingSignature = Object.keys(mapping)
            .sort()
            .map(function (key) { return key + ":" + (Array.isArray(mapping[key]) ? mapping[key].join(',') : mapping[key]); })
            .join('|');
        var powersSignature = Array.isArray(powersList)
            ? powersList.map(function (item) { return (item === null || item === void 0 ? void 0 : item.powerCode) + ":" + (item === null || item === void 0 ? void 0 : item.active) + ":" + (item === null || item === void 0 ? void 0 : item.enabled); }).join('|')
            : '';
        var specialColumnSignature = specialColumn ? Object.keys(specialColumn).sort().join('|') : '';
        var columnsSignature = Array.isArray(columns) ? columns.map(function (item) { return (item === null || item === void 0 ? void 0 : item.dataIndex) || (item === null || item === void 0 ? void 0 : item.key); }).join('|') : '';
        return [
            baseDataPropertiesSignature,
            dynamicChannelMapSignature,
            mappingSignature,
            powersSignature,
            scenesType,
            useNewFieldSet,
            specialColumnSignature,
            columnsSignature
        ].join('||');
    };
    ColumnProvider.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var e_1, _a, e_2, _b;
        var enableFmpColumnHydrate = getBoolVariation('pc-fmp-optimization');
        var columnDependencyKeys = [
            'baseDataProperties',
            'dynamicChannelMap',
            'mapping',
            'powersList',
            'scenesType',
            'useNewFieldSet',
            'specialColumn',
            'columns'
        ];
        if (enableFmpColumnHydrate &&
            this.getColumnDependencySignature(this.props) !== this.getColumnDependencySignature(nextProps)) {
            return true;
        }
        var propKeys = Object.keys(nextProps);
        try {
            for (var propKeys_1 = __values(propKeys), propKeys_1_1 = propKeys_1.next(); !propKeys_1_1.done; propKeys_1_1 = propKeys_1.next()) {
                var propKey = propKeys_1_1.value;
                if (this.props[propKey] !== nextProps[propKey]) {
                    if (enableFmpColumnHydrate && columnDependencyKeys.indexOf(propKey) > -1) {
                        continue;
                    }
                    if (propKey === 'channelList' && isEqual(this.props.channelList, nextProps.channelList)) {
                        continue;
                    }
                    if (propKey === 'powersList' && isEqual(this.props.powersList, nextProps.powersList)) {
                        continue;
                    }
                    if (propKey === 'scenes' || propKey === 'menuBar') {
                        return true;
                    }
                    return false;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (propKeys_1_1 && !propKeys_1_1.done && (_a = propKeys_1.return)) _a.call(propKeys_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var stateKeys = Object.keys(nextState);
        try {
            for (var stateKeys_1 = __values(stateKeys), stateKeys_1_1 = stateKeys_1.next(); !stateKeys_1_1.done; stateKeys_1_1 = stateKeys_1.next()) {
                var stateKey = stateKeys_1_1.value;
                if (this.state[stateKey] !== nextState[stateKey]) {
                    return true;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (stateKeys_1_1 && !stateKeys_1_1.done && (_b = stateKeys_1.return)) _b.call(stateKeys_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return false;
    };
    ColumnProvider.prototype.render = function () {
        if (!this.state.ready) {
            return null;
        }
        var columns = null;
        if (this.props.columns) {
            columns = this.props.columns;
            var _a = this.props, createAction = _a.createAction, bus = _a.bus, useNewFieldSet = _a.useNewFieldSet;
            if (createAction && useNewFieldSet) {
                var actionColumn = createAction(bus);
                actionColumn.sorter = false;
                actionColumn.allowReordering = false;
                actionColumn.allowHiding = true;
                actionColumn.allowGrouping = false;
                actionColumn.minWidth = 160;
                columns.push(actionColumn);
            }
            return this.props.children({
                columns: columns
            });
        }
        columns = this.buildColumns();
        return this.props.children({
            columns: columns
        });
    };
    ColumnProvider.prototype.buildColumns = function () {
        var _a = this.props, baseDataProperties = _a.baseDataProperties, createAction = _a.createAction, bus = _a.bus, prefixColumns = _a.prefixColumns, mapping = _a.mapping, specialColumn = _a.specialColumn, powersList = _a.powersList, dynamicChannelMap = _a.dynamicChannelMap, otherColumns = _a.otherColumns, createNodeNameColumn = _a.createNodeNameColumn, createNodeStaffColumn = _a.createNodeStaffColumn, createRiskWarningColumn = _a.createRiskWarningColumn, createHangUpColumn = _a.createHangUpColumn, createCreditColumn = _a.createCreditColumn, scenesType = _a.scenesType, inFeeTypeMode = _a.inFeeTypeMode, isDiDi = _a.isDiDi;
        var Express = powersList && powersList.find(function (o) { return o.powerCode === '110220'; });
        var columns = createColumns(baseDataProperties, prefixColumns, mapping, specialColumn, dynamicChannelMap, Express, isDiDi, scenesType, inFeeTypeMode);
        if (createNodeNameColumn) {
            columns.unshift(createNodeNameColumn());
        }
        if (createNodeStaffColumn) {
            columns.unshift(createNodeStaffColumn(defaultNodeStateStaffColumn()));
        }
        if (createRiskWarningColumn) {
            columns.unshift(createRiskWarningColumn());
        }
        if (createHangUpColumn) {
            columns.unshift(createHangUpColumn());
        }
        if (createCreditColumn && (createCreditColumn === null || createCreditColumn === void 0 ? void 0 : createCreditColumn())) {
            var column = createCreditColumn === null || createCreditColumn === void 0 ? void 0 : createCreditColumn();
            column && columns.unshift.apply(columns, __spread(column));
        }
        if (otherColumns) {
            var otherColumnsData = otherColumns();
            columns = Array.isArray(otherColumnsData) ? columns.concat(otherColumnsData) : columns.push(otherColumnsData);
        }
        if (createAction) {
            var actionColumn = createAction(bus);
            actionColumn.sorter = false;
            actionColumn.allowReordering = false;
            actionColumn.allowHiding = true;
            actionColumn.allowGrouping = false;
            actionColumn.minWidth = 160;
            if (getBoolVariation('mfrd-3884-fixed-action-column') && isString(actionColumn.title)) {
                actionColumn.headRender = function (column) {
                    return React.createElement(ColumnActionHeader, { title: column.title, bus: bus, column: column, fixedDirection: "right" });
                };
            }
            columns.push(actionColumn);
        }
        columns.forEach(function (column) {
            if (column.filterType === 'list' && column.filterDataSource instanceof Array) {
                column.lookup = {
                    dataSource: column.filterDataSource,
                    displayExpr: 'label',
                    valueExpr: 'value'
                };
            }
            if (!column.width) {
                column.width = 216;
            }
            if (['借款日期', '还款日期', '支付日期', '发起支付时间', '审批时间'].indexOf(column.title) > -1) {
                column.property = column.property || {};
                column.property.withTime = true;
            }
            if (column.key !== 'action') {
                column.allowHiding = true;
                column.allowReordering = true;
                column.allowGrouping = true;
            }
            if ((column === null || column === void 0 ? void 0 : column.filterType) === 'dateRange') {
                column.sorter = false;
            }
        });
        return columns;
    };
    ColumnProvider.defaultProps = {
        powersList: [],
        channelList: [],
        dynamicChannelMap: {}
    };
    ColumnProvider = __decorate([
        EnhanceConnect(function (state) { return ({
            channelList: state['@audit'].channelList,
            dynamicChannelMap: state['@audit'].dynamicChannelMap,
            powersList: state['@common'].powers.powersList || []
        }); })
    ], ColumnProvider);
    return ColumnProvider;
}(React.Component));
export { ColumnProvider };
var defaultNodeStateStaffColumn = function () {
    return {
        render: function (val, data) {
            var nodeState = data.nodeState;
            var staffs = getStaffShowByConfig(nodeState === null || nodeState === void 0 ? void 0 : nodeState.staffInfoForDisplay) || (nodeState === null || nodeState === void 0 ? void 0 : nodeState.staffName);
            return React.createElement("div", null, staffs || '-');
        }
    };
};
var ColumnActionHeader = function (props) {
    var title = props.title, column = props.column, fixedDirection = props.fixedDirection, bus = props.bus;
    var _a = __read(useState(!!column.fixed || false), 2), fixed = _a[0], setFixed = _a[1];
    var _b = __read(useState(false), 2), showTooltip = _b[0], setShowTooltip = _b[1];
    var _c = __read(useState(false), 2), disabled = _c[0], setDisabled = _c[1];
    useEffect(function () {
        setFixed(!!column.fixed);
    }, [column.fixed]);
    useEffect(function () {
        setDisabled(!!column.fixedDisabled);
    }, [column.fixedDisabled]);
    useEffect(function () {
        if (bus && !bus.has('table:coloumn:fixed:disabled')) {
            bus.on('table:coloumn:fixed:disabled', handleFixedDisabled);
        }
        return function () {
            if (bus) {
                bus.un('table:coloumn:fixed:disabled', handleFixedDisabled);
            }
        };
    });
    var handleFixedDisabled = function (disabled) {
        setDisabled(disabled);
    };
    var handleFixed = function () {
        if (disabled) {
            return;
        }
        var updateFixed = !fixed;
        setFixed(updateFixed);
        if (bus) {
            bus.emit('table:coloumn:fixed', column, updateFixed ? fixedDirection : false);
        }
        setShowTooltip(false);
    };
    var tooltipTitle = disabled
        ? i18n.get('屏幕宽度过小，无法固定操作列')
        : fixed
            ? i18n.get('取消固定操作列')
            : i18n.get('固定操作列');
    var color = disabled ? 'var(--eui-icon-disabled)' : fixed ? 'var(--eui-primary-pri-500)' : 'var(--eui-icon-n2)';
    return (React.createElement("div", { className: "horizontal" },
        title,
        React.createElement(Tooltip, { placement: "top", title: tooltipTitle, open: showTooltip, onOpenChange: function (visible) { return setShowTooltip(visible); } },
            React.createElement(OutlinedEditPin, { style: { marginLeft: 8, width: 16, height: 16, cursor: 'pointer' }, color: color, onClick: handleFixed }))));
};
